import React from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Accordion,
  Button,
  Badge,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";



const CourseListing = () => {
  const { language } = useLanguage();

  const courses = [
    {
      id: 1,
      title: "Foundation Course in Palliative Care for Doctors",
      overview:
        "10-day intensive training program designed specifically for MBBS and BDS doctors to build essential skills and knowledge in Palliative Care.",
      duration: "10 working days",
      fee: "₹5000",
      eligibility:
        "Registered MBBS or BDS doctors with Travancore-Cochin Medical/Dental Council registration.",
      objectives: [
        "Develop proficiency in pain management and symptom control",
        "Understand principles and philosophy of palliative and end-of-life care",
        "Enhance communication skills",
        "Gain hands-on experience in clinical and home-based care",
        "Equip participants to manage Recognized Medical Institutions (RMIs)",
      ],
      structure: {
        theory:
          "16 hours: Philosophy of palliative care, pain management, communication skills, symptom control, medical ethics",
        practical:
          "30 hours: Real-time exposure through home care settings (minimum 5 days)",
      },
      evaluation:
        "Continuous Assessment (100 marks) + Final Assessment (100 marks) = Total 200 marks (Minimum 50% required)",
      active: true, // Mark this course as active
    },
    {
      id: 2,
      title: "Foundation Course in Palliative Care for Nurses",
      overview:
        "10-day training program tailored for registered nurses to equip them with practical and theoretical knowledge in delivering compassionate palliative care.",
      duration: "10 working days",
      fee: "₹1500",
      eligibility:
        "Registered nurses with Diploma in General Nursing, B.Sc. Nursing, or M.Sc. Nursing.",
      objectives: [
        "Train nurses to meet the growing demand for palliative care services",
        "Enhance communication skills for dignified patient care",
        "Provide hands-on experience in home-based care",
        "Enable nurses to empower families in patient care at home",
        "Strengthen knowledge in core palliative care principles",
      ],
      structure: {
        theory:
          "16 hours: Introduction to palliative care, symptom management, ethics",
        practical: "30 hours: Home care, procedure-based training",
      },
      evaluation: "Continuous (100 Marks) + Final (100 Marks)",
      active: false,
    },
    {
      id: 3,
      title: "Basic Certificate Course in Palliative Nursing (BCCPN)",
      overview:
        "45-day, in-depth training program designed to equip registered nurses with the principles, skills, and values of Palliative Nursing.",
      duration: "45 working days",
      fee: "₹5000",
      eligibility:
        "Registered nurses with Diploma in General Nursing, B.Sc. Nursing, or M.Sc. Nursing.",
      objectives: [
        "Enable nurses to incorporate palliative care principles into everyday practice",
        "Train nurses to manage physical, psychological, and spiritual symptoms",
        "Enhance skills in communication, home care, and interdisciplinary collaboration",
        "Prepare nurses to serve as trainers and leaders in palliative care",
      ],
      structure: {
        theory:
          "30+ modules including pain management, communication, ethics, emergencies",
        practical:
          "120 hours of clinical exposure (minimum 90 hours in home care)",
      },
      evaluation: "Continuous (60 Marks) + Final (140 Marks)",
      active: false,
    },
    {
      id: 4,
      title: "Community Certificate Course in Palliative Nursing (CCCPN)",
      overview:
        "Comprehensive, hands-on training program designed to equip ANMs, JPHNs, and nurses with SSLC with practical knowledge in home-based palliative nursing.",
      duration: "180 working days",
      fee: "Contact for pricing",
      eligibility:
        "Candidates with SSLC qualification and valid ANM or JPHN certificate.",
      objectives: [
        "Equip community health workers with palliative care skills",
        "Focus on long-term care needs of patients with degenerative illnesses",
        "Develop practical skills for home-based care",
      ],
      structure: {
        theory:
          "Anatomy & Physiology (28 hrs), Fundamentals of Nursing (34 hrs), Pharmacology (16 hrs), Palliative Nursing (122 hrs)",
        practical:
          "Vital signs, injections, catheterization, home care planning & delivery",
      },
      evaluation: "Continuous (250 Marks) + Final (250 Marks)",
      active: false,
    },
  ];

  return (
    <Container
      data-aos="fade-up"
      fluid
      style={{ width: "100%", maxWidth: "100%" }}
    >
      <Row className="mb-1 text-center">
        <Col>
          <h1 className="display text-primary text-danger">
            {language === "en" ? "Training Programs" : "പരിശീലന പരിപാടികൾ"}
          </h1>
          <h3 className="lead text-muted font-small">
            {language === "en"
              ? "Comprehensive training courses for healthcare professionals to deliver compassionate palliative care"
              : "പാലിയേറ്റീവ് പരിചരണം നൽകാൻ ആരോഗ്യരംഗത്ത് പ്രവർത്തിക്കുന്നവർക്ക് വേണ്ട സവിശേഷ പരിശീലന കോഴ്സുകൾ"}
          </h3>
        </Col>
      </Row>
      <Container className="py-5">
        <Row className="g-2">
          {courses.map((course) => (
            <Col key={course.id} md={6} lg={3}>
              <Card className="h-100 shadow-sm p-1 position-relative">
                {/* Active Course Ribbon */}
                {course.active && (
                  <div
                    className="position-absolute"
                    style={{
                      top: "-10px",
                      right: "-10px",
                      zIndex: 1,
                    }}
                  >
                    <span className="badge bg-danger p-2">
                      Applications invited
                    </span>
                  </div>
                )}

                <Card.Header
                  className="text-white position-relative"
                  style={{ backgroundColor: "#008080" }}
                >
                  <h5>{course.title}</h5>
                </Card.Header>
                <Card.Body>
                  <Badge bg="info" className="mb-2">
                    Duration: {course.duration}
                  </Badge>
                  <Badge bg="success" className="mb-2 ms-2">
                    Fee: {course.fee}
                  </Badge>
                  <Card.Text className="mt-2">{course.overview}</Card.Text>

                  <Accordion flush>
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>
                        {language === "en" ? "Eligibility" : "യോഗ്യത"}
                      </Accordion.Header>
                      <Accordion.Body>{course.eligibility}</Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="1">
                      <Accordion.Header>
                        {language === "en" ? "Course Objectives" : "കോഴ്സിന്റെ ലക്ഷ്യങ്ങൾ"}
                      </Accordion.Header>
                      <Accordion.Body>
                        <ul className="mb-0">
                          {course.objectives.map((obj, i) => (
                            <li key={i}>{obj}</li>
                          ))}
                        </ul>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="2">
                      <Accordion.Header>
                        {language === "en" ? "Course Structure" : "കോഴ്സ് ഘടന"}
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>
                          <strong>Theory:</strong> {course.structure.theory}
                        </p>
                        <p>
                          <strong>Practical:</strong>{" "}
                          {course.structure.practical}
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="3">
                      <Accordion.Header>
                        {language === "en" ? "Evaluation" : "മൂല്യനിർണ്ണയം"}
                      </Accordion.Header>
                      <Accordion.Body>{course.evaluation}</Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </Card.Body>
                <Card.Footer className="text-center">
                  {course.active ? (
                    <Link as={Link} to="/courseapplication">
                      <Button variant="outline-success">
                        {language === "en" ? "Apply Now" : "ഇപ്പോൾ അപേക്ഷിക്കൂ"}
                      </Button>
                    </Link>
                  ) : (
                    <Button variant="outline-success" disabled>
                      {language === "en" ? "Apply Now" : "ഇപ്പോൾ അപേക്ഷിക്കൂ"}
                    </Button>
                  )}
                </Card.Footer>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
      <Row className="mt-5">
        <Col className="text-center">
          <div className="p-4 bg-light rounded">
            <h3>{language === "en" ? "Need Help Choosing a Course?" : " കോഴ്സ് തിരഞ്ഞെടുക്കാൻ സഹായം വേണോ?"}</h3>
            <p className="lead">{language === "en" ? "Contact our admissions team for guidance" : "നിർദ്ദേശങ്ങൾക്ക് ഞങ്ങളുടെ അഡ്മിഷൻ ടീമിനെ ബന്ധപ്പെടുക"}</p>
            <Link as={Link} to="/contactus">
              <Button variant="primary" size="lg">
                {language === "en" ? "Contact Us" : "ഞങ്ങളെ ബന്ധപ്പെടുക"}
              </Button>
            </Link>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default CourseListing;